import { XCircleIcon } from '@heroicons/react/24/solid'
import { HTMLInputTypeAttribute } from 'react'
import { Label } from '../../Label'

export interface InputFieldProps {
    label?: string
    name: string
    type?: HTMLInputTypeAttribute
    onChange: React.ChangeEventHandler<HTMLInputElement>
    onBlur?: React.FocusEventHandler<HTMLInputElement>
    value?: string
    componentRef?: React.LegacyRef<HTMLInputElement>
    className?: string
    placeholder?: string
    step?: React.InputHTMLAttributes<HTMLInputElement>['step']
    disabled?: boolean
    hasClearButton?: boolean
}

type TInputField = React.FC<InputFieldProps>

const InputField: TInputField = ({
    label,
    name,
    type = 'text',
    onChange,
    onBlur,
    value,
    componentRef,
    className,
    placeholder,
    step = 0.001,
    disabled,
    hasClearButton = false
}) => {
    const numberFieldProps: { step?: InputFieldProps['step'] } = {}

    if (type === 'number') {
        numberFieldProps.step = step
    }

    return (
        <div>
            {label ? <Label>{label}</Label> : ''}
            <div className='relative'>
                <input
                    className={className}
                    type={type}
                    name={name}
                    onChange={onChange}
                    onBlur={onBlur}
                    value={value}
                    ref={componentRef}
                    placeholder={placeholder}
                    disabled={disabled}
                    {...numberFieldProps}
                />
                {hasClearButton && value && (
                    <button
                        type='button'
                        className='absolute right-0 top-1/2 -translate-y-1/2 p-1'
                        onClick={() => onChange({ target: { value: '' } } as React.ChangeEvent<HTMLInputElement>)}
                    >
                        <XCircleIcon className='w-6 text-sky-500' />
                    </button>
                )}
            </div>
        </div>
    )
}

export default InputField
